export const ImportantOptions = [
  'localReviewCount',
  'overallDaysOnMarket',
  'localSoldListings',
  'overallSoldSamePropertyType',
  'overallBestPrice',
] as const;
export type ImportantOptionType = (typeof ImportantOptions)[number];
